module.exports = __webpack_public_path__ + "static/media/blogs_image.e2cab687.svg";